/**
 * Types de domaine partages par le client et le serveur.
 *
 * Ces objets sont ceux qui transitent sur le reseau : ils sont en camelCase.
 * La base SQLite, elle, est en snake_case ; la conversion est la
 * responsabilite exclusive des modules `repo/` du serveur.
 */
export const CATEGORIES = [
    'ville', 'rando', 'spot', 'hebergement', 'resto', 'transport', 'autre',
];
export const EMPTY_STATE = {
    members: [], places: [], votes: [], comments: [], photos: [],
};
